import { Pipe, PipeTransform } from '@angular/core';
import * as momentClass from 'moment';
// This is mainly just to satisfy Jest
import * as moment from 'moment';

/**
 * A formatter that formats the date/time in an unambiguous way.
 */
@Pipe({ name: 'formatDateTimeUniversal' })
export class FormatDateTimeUniversalPipe implements PipeTransform {
    transform(
        dateTimeStr: string | Date | moment.Moment,
        timeZone?: string
    ): string | null {
        if (!dateTimeStr) {
            return null;
        }
        if (momentClass.isMoment(dateTimeStr)) {
            return moment(dateTimeStr).format('HH:mm D MMM YYYY zz');
        }

        if (timeZone != null) {
            return moment(dateTimeStr)
                .tz(timeZone)
                .format('HH:mm D MMM YYYY zz');
        }

        return moment(dateTimeStr).format('HH:mm D MMM YYYY');
    }
}
